import React from 'react'
import RadioInput from '@/modules/base/components/inputs/radio-input/radio-input'
import lang from '@/lang'
import useCheckModuleAccess from '@/modules/_helpers/accessCheck/useCheckModuleAccess'
import { SUBSCRIPTION_MODULES } from '@/modules/base/util/constants'
import { BookingTarget } from './review-target'
import styles from './booking-target-radio.css'

// FLAG:useDocuAi — mounted only in the gated invoice-review header.
const BookingTargetRadio = ({ value, onChange, allowDocumentTarget = true }: {
  value: BookingTarget
  onChange?: (target: BookingTarget) => void
  /**
   * FLAG:useDocuAi — may „Nur Dokument“ be offered at all? Decision Ralf, 2026-09-16: NOT in the
   * review embedded in Ausgaben/Einnahmen. Somebody who opened „Neue Ausgabe" and uploaded an
   * invoice there has already said where it belongs; „Nur Dokument" would undo that from inside the
   * very surface that asserts it. Correcting expense ↔ revenue stays possible — that is the case
   * where the analysis and the entry point genuinely disagree (a credit note uploaded via Ausgaben).
   * The Documents review surfaces keep all three: there the ledger really is open.
   */
  allowDocumentTarget?: boolean
}) => {
  // FLAG:useDocuAi — „Nur Dokument“ is a Documents-module capability. An accounting-only tenant
  // can correct expense ↔ revenue, but must not be offered a destination it cannot open afterwards.
  const hasDocumentsModule = useCheckModuleAccess(SUBSCRIPTION_MODULES.DOCUMENTS)
  const options = [
    { value: 'expense', label: lang.documents.reviewBookingTarget.expenseLabel },
    { value: 'revenue', label: lang.documents.reviewBookingTarget.revenueLabel },
    ...(hasDocumentsModule && allowDocumentTarget
      ? [{ value: 'document', label: lang.documents.reviewBookingTarget.documentLabel }]
      : []),
  ]

  return (
    <RadioInput
      name='documentReviewBookingTarget'
      dataQsId='receiptReview-bookingTarget'
      customOptionClass={styles.option}
      label={lang.documents.reviewBookingTarget.choiceLabel}
      value={value}
      onChange={onChange}
      options={options}
    />
  )
}
export default BookingTargetRadio
